import {
  WorksheetBatchUpdateCommonDefaultParams,
  WorksheetBatchUpdateCommonQueryFields,
  WorksheetBatchUpdateCommonRequiredParams,
} from 'Components/WorksheetBatchUpdate/Core/SharedQueryFields';
import { WorksheetBatchUpdateDefinition } from '../..';
import { BsSandReplacementQueryFields } from './BsSandReplacementQueryFields';
import {
  BsSandReplacementWorksheetFields,
  BsSandReplacementWorksheetSections,
} from './BsSandReplacementWorksheetFields';

const BsSandReplacementBatchUpdateDefinition: WorksheetBatchUpdateDefinition = {
  worksheetType: 'Sand Replacement',
  query: {
    defaultParams: WorksheetBatchUpdateCommonDefaultParams,
    requiredParams: WorksheetBatchUpdateCommonRequiredParams,
  },
  queryFields: {
    ...WorksheetBatchUpdateCommonQueryFields,
    ...BsSandReplacementQueryFields,
  },
  worksheetFields: BsSandReplacementWorksheetFields,
  worksheetFieldSections: BsSandReplacementWorksheetSections,
};

export default BsSandReplacementBatchUpdateDefinition;

export { BsSandReplacementBatchUpdateDefinition };
